// extracted by mini-css-extract-plugin
export var noSpinners = "_my-6";
export var percentageInput = "_my-7";
export var variantColor1 = "_my-0";
export var variantColor2 = "_my-1";
export var variantColor3 = "_my-2";
export var variantColor4 = "_my-3";
export var variantColor5 = "_my-4";
export var variantColor6 = "_my-5";